import { Component, OnInit } from '@angular/core';
import {EnvConfigurationService} from '@core/services/env-configuration.service';
import * as safetyRecommendationConstants from '../../../features/safety-recommendations/safety-recommendations.constants';

@Component({
     selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  e2ClientIndexHTMLVersion: string;
  e2ClientConfigJSONVersion: string;

    constructor(private configService: EnvConfigurationService) { }


  ngOnInit(): void {
    if (localStorage.getItem(safetyRecommendationConstants.SHOW_VERSIONS_STORAGE_KEY)) {
      this.e2ClientIndexHTMLVersion = (window as any).e2ClientIndexHTMLVersion;
      this.e2ClientConfigJSONVersion = this.configService.env.e2ClientConfigJSONVersion;
    }
  }

}
